// IndexedDB-backed hold for project cover uploads. Images are too large/binary
// for localStorage, so a failed upload is stashed here and auto-retried later —
// the art survives a sleeping backend, crashes and refreshes.
const DB_NAME = "codexstudio";
const STORE = "pendingCovers";

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE, { keyPath: "projectId" });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function run(mode, fn) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, mode);
    const store = tx.objectStore(STORE);
    const request = fn(store);
    tx.oncomplete = () => resolve(request && request.result);
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
  });
}

export const putPendingCover = (projectId, blob, filename) =>
  run("readwrite", (s) => s.put({ projectId, blob, filename, ts: Date.now() }));

export const removePendingCover = (projectId) =>
  run("readwrite", (s) => s.delete(projectId));

export const getAllPendingCovers = () =>
  run("readonly", (s) => s.getAll());
